import { integrationTypeFilterInDrawerValue } from '@modules/integrationsV2/types';
import { getIconForIntegrationType } from '@modules/integrationsV2/utils';
import { FilterListRounded } from '@mui/icons-material';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Typography,
} from '@mui/material';
import { IntegrationType } from 'generated/graphql';
import { capitalize } from 'lodash';

interface IntegrationTypeFilterProps {
  value: integrationTypeFilterInDrawerValue;
  onChange: (value: integrationTypeFilterInDrawerValue) => void;
}

export const IntegrationTypeFilter = ({
  value,
  onChange,
}: IntegrationTypeFilterProps) => {
  const renderIntegrationTypeOption = (integrationType: IntegrationType) => {
    return (
      <Stack spacing={1} direction="row" alignItems="center">
        {getIconForIntegrationType({
          integrationType,
          fontSize: 'small',
        })}
        <Typography>{capitalize(integrationType)}</Typography>
      </Stack>
    );
  };

  const handleChangeintegrationTypeFilterInDrawer = (
    event: SelectChangeEvent<integrationTypeFilterInDrawerValue>,
  ) => {
    onChange(event.target.value as integrationTypeFilterInDrawerValue);
  };

  return (
    <FormControl>
      <InputLabel id="integration-type-filter">Type</InputLabel>
      <Select
        labelId="integration-type-filter"
        label="Type"
        value={value}
        onChange={handleChangeintegrationTypeFilterInDrawer}
        size="small"
        sx={{
          width: 200,
        }}
      >
        <MenuItem value="all">
          <Stack spacing={1} direction="row" alignItems="center">
            <Box>
              <FilterListRounded
                fontSize="small"
                sx={{
                  color: 'text.secondary',
                }}
              />
            </Box>
            <Typography>All Types</Typography>
          </Stack>
        </MenuItem>
        <MenuItem value={IntegrationType.Feedback}>
          {renderIntegrationTypeOption(IntegrationType.Feedback)}
        </MenuItem>
        <MenuItem value={IntegrationType.User}>
          {renderIntegrationTypeOption(IntegrationType.User)}
        </MenuItem>
        <MenuItem value={IntegrationType.Account}>
          {renderIntegrationTypeOption(IntegrationType.Account)}
        </MenuItem>
        <MenuItem value={IntegrationType.Cohorts}>
          {renderIntegrationTypeOption(IntegrationType.Cohorts)}
        </MenuItem>
      </Select>
    </FormControl>
  );
};
